// extracted by mini-css-extract-plugin
export default {"wrapper":"s8QYrd8wQFt9hLjWUsujmw==","error-illustration":"aY0uwwz7lKi+yqxk75SSsw=="};